import type { FC } from 'react';
import { CopyAlternative, ShareOutline } from '@eqi-investimentos/icons/web';
import { Flex, Text, Input } from '@eqi-investimentos/react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { ToastButton } from '@/components/modules/ToastButton';

export const ModalShareEvent: FC<ModalShareEventProps> = ({
  isOpen,
  linkUrl,
  copyLinkShare,
  onClose,
  t,
}) => {
  if (!isOpen) return <></>;

  const urlPath = checkLinkUrl(linkUrl);

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent w="23.4375rem" minH="23.25rem">
        <ModalCloseButton top="2rem" right="2rem" />
        <ModalBody w="full" transition="all 0.5s ease">
          <Flex
            w="full"
            minH="23rem"
            flexDir="column"
            alignItems="start"
            justifyContent="center"
            gap="2xl"
            p="l"
            pt="5xl"
          >
            <ShareOutline
              width="4.25rem"
              height="4.25rem"
              color="content.brand"
            />
            <Text
              textAlign="start"
              size="h6"
              fontWeight="normal"
              color="content.primary"
            >
              {t('screens.events.share.title')}
            </Text>
            <Text
              textAlign="start"
              size="xl"
              fontWeight="normal"
              color="content.secondary"
            >
              {t('screens.events.share.description')}
            </Text>
            <Flex
              w="full"
              flexDir="column"
              alignItems="center"
              mt="1rem"
              sx={{
                '.chakra-input__group': {
                  ':hover': {
                    button: { bg: 'transparent' },
                  },
                },
              }}
            >
              <Input
                type="text"
                isReadOnly
                value={urlPath}
                rightIcon={
                  <ToastButton
                    ariaLabel="input-icon-buttton-copy-alternative"
                    id="input-icon-buttton-copy-alternative"
                    onClick={async () => copyLinkShare(urlPath)}
                    disableStartToast
                    icon={CopyAlternative}
                    customToastsConfig={{
                      success: {
                        description: undefined,
                        title: t('screens.events.share.copied'),
                      },
                    }}
                    iconProps={{
                      w: 24,
                      h: 24,
                      color: 'content.brand',
                    }}
                  />
                }
              />
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

type ModalShareEventProps = {
  isOpen: boolean;
  linkUrl: string | null;
  copyLinkShare: (urlPath: string) => Promise<boolean>;
  onClose: () => void;
  t: (key: string) => string;
};

const checkLinkUrl = (linkUrl: string | null) => {
  if (linkUrl?.startsWith('http')) {
    return linkUrl;
  }
  return window.location.origin + linkUrl;
};
